import * as amplitude from '@amplitude/unified';
import { LOCAL_STORAGE_USER_KEY } from '@config/auth';

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

export const identifyAmplitudeUser = (userKey: string) => {
  amplitude.setUserId(userKey);
};

export const initAmplitude = () => {
  if (!AMPLITUDE_API_KEY) {
    console.warn('amplitude config failed: no API key');
    return;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.warn('amplitude config skipped: not production');
    return;
  }

  amplitude.initAll(AMPLITUDE_API_KEY, {
    analytics: {
      autocapture: {
        attribution: true,
        fileDownloads: true,
        formInteractions: true,
        pageViews: true,
        sessions: true,
        elementInteractions: true,
        networkTracking: true,
        webVitals: true,
        frustrationInteractions: {
          thrashedCursor: true,
          errorClicks: true,
          deadClicks: true,
          rageClicks: true,
        },
      },
    },
    sessionReplay: {
      sampleRate: 1,
    },
  });

  const userKey = localStorage.getItem(LOCAL_STORAGE_USER_KEY);
  if (userKey) identifyAmplitudeUser(userKey);

  console.log('[Amplitude] Initialized successfully');
};

export const trackEvent = (eventName: string, eventProperties?: Record<string, unknown>) => {
  amplitude.track(eventName, eventProperties);
};
